<div id="opta-action-areas"></div>
